export default "__VITE_ASSET__BJwKT8Bn__"